<template>
  <ModalContainer queryParam="code" ref="modalContainer">
    <b-card>
      <div class="mb-1">Codigo Orion:</div>
      <b-form-input 
        v-model="codigoOrion"
        type="number"
      />

      <div class="d-flex justify-content-end">
        <b-button 
          variant="primary" 
          class="mt-2"
          @click="onSaveCode"
          :disabled="!codigoOrion"
        >
          Guardar
        </b-button>
      </div>
    </b-card>
  </ModalContainer>
</template>

<script>
import { ModalContainer } from "@/shared/components";
import { labAuxiliarService } from "../../services";

export default {

  name: "CodigoOrionAux",

  components: {
    ModalContainer
  },


  data() {
    return {
      tokenAuxiliar: null,
      codigoOrion: null,
      estadoLaboratorio: null
    }
  },


  created() {
    this.setTokenAuxiliar();
  },

  methods: {


    async setTokenAuxiliar() {
      this.tokenAuxiliar = this.$route.query.code;

      if(!this.tokenAuxiliar) return;

      const responseSearch = await labAuxiliarService.getAll({ tokenLaboratorio: this.tokenAuxiliar });

      if(!responseSearch || !responseSearch.data?.length) {
        await this.$swal({
          icon: 'error',
          title: 'No se encontro el auxiliar',
          showConfirmButton: true,
        });

        this.$refs.modalContainer.closeModal();

        return;
      }

      const [auxiliar] = responseSearch.data;

      this.codigoOrion = auxiliar.codigoOrion;
      this.estadoLaboratorio = auxiliar.estadoLaboratorio;
    },


    async onSaveCode() {
      const estadoActual = this.estadoLaboratorio ? String(this.estadoLaboratorio) : null;

      const fieldsToUpdate = {
        codigoOrion: this.codigoOrion,
      };

      if (estadoActual === '2') {
        fieldsToUpdate.estadoLaboratorio = '3';
      }

      const responseUpdate = await labAuxiliarService.updateByToken(this.tokenAuxiliar, fieldsToUpdate);

      if(!responseUpdate) {
        await this.$swal({
          icon: 'error',
          title: 'No se pudo actualizar el auxiliar',
          showConfirmButton: true,
        });

        return;
      }

      if (Object.prototype.hasOwnProperty.call(responseUpdate, 'labAuxiliar') && responseUpdate.labAuxiliar === null) {
        await this.$swal({
          icon: 'error',
          title: responseUpdate.message,
          showConfirmButton: true,
        });

        return;
      }

      await this.$swal({
        icon: 'success',
        title: 'Auxiliar actualizado',
        showConfirmButton: true,
      });

      const nuevoEstado = responseUpdate.estadoLaboratorio
        || (estadoActual === '2' ? '3' : estadoActual);

      this.estadoLaboratorio = nuevoEstado;

      await this.$refs.modalContainer.closeModal();
      this.$router.go();
    }
  },

  watch: {

    '$route.query.code': {
      handler() {
        this.setTokenAuxiliar();
      }
    }
  }

};
</script>
